import { tokenPlaceholder } from '@montugroup/circuit-shared/constants/escript';
import { TextField } from '@montugroup/design-system';
import type { Path } from 'react-hook-form';
import type { TokenTextFieldProps } from './types';

export function TokenTextField<TFieldValues extends Record<string, any>, TName extends Path<TFieldValues>>({
  field,
  fieldState,
}: TokenTextFieldProps<TFieldValues, TName>) {
  const { onChange, value, ref } = field;
  const { error } = fieldState;

  return (
    <TextField
      type="text"
      variant="outlined"
      value={value}
      inputRef={ref}
      onChange={(event) => {
        const removeWhitespaceValue = event.target.value.replace(/\s/g, '');
        onChange(removeWhitespaceValue);
      }}
      label={tokenPlaceholder}
      error={!!error}
      helperText={error ? <span data-dd-privacy="allow">{error.message}</span> : ''}
      fullWidth
    />
  );
}
